import {ChangeDetectionStrategy, Component, forwardRef} from '@angular/core';
import {NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {OneLineObjectComponent} from './one-line-object.component';

@Component({
  selector: 'app-one-line-address-control',
  template: `
    <app-address-list-control
      [formControl]="objectListControl"
      [parentId]="newObjParentId"
      [maxCount]="1"
      [showOwner]="showOwner"
      [customStyle]="customStyle"
      [setMatAutocomplete]="false"
      [label]="label"
      [isRequired]="isRequired"
      [isLoading]="isLoading"
    >
    </app-address-list-control>
  `,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => OneLineAddressComponent),
      multi: true,
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OneLineAddressComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OneLineAddressComponent extends OneLineObjectComponent {
  constructor() {
    super();
  }
}
